import Image from "next/image";

import { cn } from "@/lib/utils";
import { clashGrotesk, jakartaSans } from "@/styles/fonts";

import type { CaseStudy } from "@/pages/case-studies/[slug]";

export default function BeforeAfter({ beforeRebolt, afterRebolt }: Pick<CaseStudy, "beforeRebolt" | "afterRebolt">) {
  return (
    <section className={cn("flex flex-col md:flex-row px-4", jakartaSans.variable, clashGrotesk.variable)}>
      <div className="bg-ash-100 w-full flex flex-col gap-12 md:gap-24 items-center justify-center py-12 md:py-24 px-4 mx-auto rounded-3xl">
        <section className="flex flex-col justify-center items-center shrink-0 text-center gap-8 md:gap-14 w-full">
          <h1
            className="font-clash font-medium text-4xl md:text-5xl leading-[0.95] tracking-snug text-center relative text-ash-900"
            itemProp="headline"
          >
            The Impact
          </h1>
          <div className="max-w-7xl w-full flex-col md:flex-row flex gap-6">
            <div className="flex flex-col text-start items-start justify-start gap-6 md:gap-12 w-full h-fit bg-white text-ash-900 rounded-2xl py-8 px-6">
              <p className="md:text-4xl text-3xl font-clash font-medium ">Before Rebolt</p>
              <div className="flex flex-col gap-3 w-full ">
                {beforeRebolt.map((item, index) => (
                  <div key={index} className="flex flex-col gap-1 w-full bg-ash-100 rounded-2xl p-6">
                    <p className="font-semibold text-xl">{item.fields.header}</p>
                    <p className="font-medium text-base">{item.fields.subheader}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col text-start items-start justify-start gap-6 md:gap-12 w-full h-fit bg-rebolt-500 rounded-2xl py-8 px-6 text-white">
              <div className="flex flex-row items-center justify-between gap-4 w-full">
                <p className="md:text-4xl text-3xl font-clash font-medium">After Rebolt</p>
                <div className="w-auto h-8 -mt-1 flex items-end justify-end">
                  <Image
                    src="/rebolt-branding/mark-white.png"
                    alt="Rebolt Logo"
                    height={100}
                    width={100}
                    className="w-auto h-8 object-contain"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-3 w-full text-ash-900">
                {afterRebolt.map((item, index) => (
                  <div key={index} className="flex flex-col gap-1 w-full bg-rebolt-100 rounded-2xl p-6">
                    <p className="font-semibold text-xl">{item.fields.header}</p>
                    <p className="font-medium text-base">{item.fields.subheader}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}
